import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CACHEABLE } from '../_helpers/cache.interceptor';
import { EndpointService } from './endpoint.service';
import { ToastService } from './toast.service';
import { AiAnalystSuccessMetricsSummary } from '../models/aiAnalystSuccessMetricsSummary.model';
import { AiUsageByUserResponse } from '../models/aiUsageByUser.model';
import { AiUsageDimension } from '../enums/aiUsageDimension.enum';

@Injectable({
    providedIn: 'root'
})
export class AiAnalystMetricsService extends EndpointService {

    constructor(http: HttpClient, private readonly toastService: ToastService) {
        super(http);
    }

    getUsageByUser(month: string, groupBy: AiUsageDimension, crossTenant: boolean): Observable<AiUsageByUserResponse | null> {
        const params = new HttpParams()
            .set('month', month)
            .set('groupBy', groupBy);
        const action = crossTenant ? 'GetCrossTenantUsageByUser' : 'GetUsageByUser';
        return this.http.get<AiUsageByUserResponse>(
            this.getApiUrl(`AiAnalystMetrics/${action}`),
            { params, context: new HttpContext().set(CACHEABLE, true) }
        ).pipe(
            catchError((error: unknown) => {
                this.toastService.showError(error);
                return of(null);
            })
        );
    }

    getSuccessMetricsSummary(startDate: string, endDate: string): Observable<AiAnalystSuccessMetricsSummary | null> {
        const params = new HttpParams()
            .set('startDate', startDate)
            .set('endDate', endDate);
        return this.http.get<AiAnalystSuccessMetricsSummary>(
            this.getApiUrl('AiAnalystMetrics/GetSuccessMetricsSummary'),
            { params }
        ).pipe(
            catchError((error: unknown) => {
                this.toastService.showError(error);
                return of(null);
            })
        );
    }
}
